/*eslint-disable*/
export default careGuide => {
  let bxPusher = false
  $(window).load(() => {
    $('.snowe__loader').addClass('hide')
    $('.bx-pusher').length && careGuide.classList.add('bx-open')
    bxPusher = true
    $('.bx-pusher') && $('.bx-base').on('DOMSubtreeModified', function () {
      careGuide.classList.remove('bx-open')
      bxPusher = false
    })
    // Need to figure out a way to drop the title when BX appears after page is already loaded - i.e. when someone adds someting to cart. Although i suppose they can't do so from this page unless with cart upsell or changing quantity. Will this trigger the BX cart banner?
  })
  let categoryContainers = careGuide.querySelectorAll('.category-container')
  let productContainers = careGuide.querySelectorAll('.product-container')
  let letterContainers = careGuide.querySelectorAll('.letter-products')
  $('#product-search').focus(() => {
    if (window.matchMedia('(max-width: 767px)').matches) {
      /webOS|iPhone|iPad|iPod/i.test(navigator.userAgent) ? $('html, body').animate({ scrollTop: 270 }, 150) : $('html, body').animate({ scrollTop: 173 }, 150)
    }
  })
  $('#product-search').focusout(() => { window.matchMedia('(max-width: 767px)').matches && $('#product-search').val().length <= 0 && $('html, body').animate({ scrollTop: 0 }, 150) })

  $(window).load(() => {
    handleClearSearch()
    handleResetCounterAndLetters()
  })
  let initialScrollPos = window.pageYOffset
  let currentScrollPos = initialScrollPos
  const addScrollListener = (scrollElement) => {
    currentScrollPos = window.pageYOffset
    if (currentScrollPos < 800) {
      $(scrollElement).addClass('hide-scroll')
    }
    if (currentScrollPos < initialScrollPos && currentScrollPos >= 800) {
      $(scrollElement).removeClass('hide-scroll')
      initialScrollPos = currentScrollPos
    } else if (currentScrollPos > initialScrollPos + 300) {
      initialScrollPos = currentScrollPos
      $(scrollElement).addClass('hide-scroll')
    }
  }
  $(window).on('scroll load', (e) => { addScrollListener($('#scroll-to-top').get(0)) })
  $('#scroll-to-top').click(() => $('html, body').animate({ scrollTop: 0 }, 150))
  $('.clear-search').click(() => {
    $('html, body').animate({ scrollTop: 0 }, 150)
    handleClearCategory()
    handleClearSearch()
    handleResetCounterAndLetters()
    window.matchMedia('(max-width: 767px)').matches && $('#product-search').val().length <= 0 && $('html, body').animate({ scrollTop: 0 }, 150)
  })

  const handleClearCategory = () => {
    $('.care-guide_right-products-container').data('selected-category', '')
    categoryContainers.forEach(categoryContainer => {
      $(categoryContainer).find('.expand-arrow').removeClass('active inactive')
      $(categoryContainer).find('h3').removeClass('selected deselected')
    })
    window.matchMedia('(max-width: 767px)').matches && $('#product-search').val().length <= 0 && $('html, body').animate({ scrollTop: 0 }, 150)
  }
  const handleClearSearch = () => {
    // Hides search term and product count on left side
    $('#product-search').val('')
    $('.search-term-container').addClass('hidden').find('.product-count').text('')
    // Hides or Unhides letter category based on which category selection is made and if products exist under that letter
    productContainers.forEach(productContainer => {
      $(productContainer).removeClass('hidden').css('border-top', 'none')
      let $letterContainer = $(productContainer).closest('.letter-products')
      $letterContainer.find('.section-letter-header').removeClass('hidden')
      $letterContainer.find('.product-container:not(.hidden)').first().css('border-top', 'none')
    })
  }
  const handleResetCounterAndLetters = () => {
    letterContainers.forEach(letterContainer => {
      let $letterContainer = $(letterContainer)
      let productsShownCount = $letterContainer.find('.product-container:not(.hidden)').length
      $letterContainer.find('.product-container:not(.hidden)').first().css('border-top', 'none')
      if (productsShownCount <= 0 || $('#product-search').val().length > 0) {
        $letterContainer.find('.section-letter-header').addClass('hidden')
      } else {
        let productsShownText = productsShownCount > 1 ? `${productsShownCount} Products` : `${productsShownCount} Product`
        $letterContainer.find('.product-count').text(productsShownText)
        $letterContainer.find('.section-letter-header').removeClass('hidden')
      }
    })
  }
  letterContainers.forEach(letterContainer => {
    let productCountText = letterContainer.querySelectorAll('.product-container').length > 1 ? `${letterContainer.querySelectorAll('.product-container').length} Products` : `${letterContainer.querySelectorAll('.product-container').length} Product`
    $(letterContainer).find('.product-count').text(productCountText)
  })

  // Handles Clicking on category
  categoryContainers.forEach(categoryContainer => {
    categoryContainer.addEventListener('click', (e) => {
      let category = categoryContainer.querySelector('h3')
      let $expandArrow = $(category).closest('.category-container').find('.expand-arrow')
      // if clicking on category that is already selected, deselect category
      if ($expandArrow.hasClass('active')) {
        handleClearCategory()
        handleClearSearch()
        let scrollDuration = $(window).scrollTop() < 150 ? 0 : 150
        $('html, body').animate({ scrollTop: 0 }, scrollDuration, () => handleResetCounterAndLetters())
      } else {
        handleClearCategory()
        handleClearSearch()
        $('.care-guide_right-products-container').data('selected-category', category.id)
        categoryContainers.forEach(categoryContainer => {
          $(categoryContainer).find('.expand-arrow').addClass('inactive')
          $(categoryContainer).find('h3').addClass('deselected')
        })
        $expandArrow.addClass('active').removeClass('inactive')
        $(category).addClass('selected').removeClass('deselected')
        let scrollDuration = $(window).scrollTop() < 150 ? 0 : 150
        $('html, body').animate({ scrollTop: 0 }, scrollDuration, () => {
          productContainers.forEach(productContainer => $(productContainer).data('category-1') !== category.id && $(productContainer).data('category-2') !== category.id ? productContainer.classList.add('hidden') : productContainer.classList.remove('hidden'))
          handleResetCounterAndLetters()
        })
      }
    }) // end category onClick
  }) // end category for each

  // Handles clicking on product
  productContainers.forEach(productContainer => {
    productContainer.addEventListener('click', (e) => {
      $('#scroll-to-top').addClass('hide-scroll')
      !e.target.classList.contains('pdp-link') && productContainer.classList.contains('open')
        ? productContainer.classList.remove('open')
        : productContainer.classList.add('open')
      let expandArrow = productContainer.querySelector('.expand-arrow')
      expandArrow.classList.contains('active') ? $(expandArrow).addClass('inactive').removeClass('active') : $(expandArrow).addClass('active').removeClass('inactive')
    })
  })
  $('#product-search').on('input', (e) => {
    if (window.matchMedia('(max-width: 767px)').matches) {
      /webOS|iPhone|iPad|iPod/i.test(navigator.userAgent) ? $('html, body').animate({ scrollTop: 270 }, 150) : $('html, body').animate({ scrollTop: 173 }, 150)
    } else $('html, body').animate({ scrollTop: 0 }, 0)
    if (e.target.value.length > 0) {
      $('.letter-products').find('.section-letter-header').each((idx, letterHeader) => letterHeader.classList.add('hidden'))
      productContainers.forEach(productContainer => {
        $(productContainer).css('border-top', 'none')
        let searchTerm = $('#product-search').val()
        let productName = productContainer.querySelector('h3').innerHTML.toLowerCase().replace('&amp;', 'and')
        // if not category is selected, show and hide dependent soley on search
        if (productName.includes(searchTerm.toLowerCase())) {
          $(productContainer).removeClass('hidden')
        } else $(productContainer).addClass('hidden')
      })
      handleClearCategory()
      let productCountText = $('.product-container:not(.hidden)').length > 1 ? `${$('.product-container:not(.hidden)').length} Products` : `${$('.product-container:not(.hidden)').length} Product`
      $('.search-term-container').removeClass('hidden').find('.product-count').text(productCountText)
    } else {
      handleClearSearch()
      handleResetCounterAndLetters()
    }
    $('.search-term').text(e.target.value)
  })
}



// WEBPACK FOOTER //
// ./src/scripts/components/care-guide-js.js